import { render, staticRenderFns } from "./MyComments.vue?vue&type=template&id=5081528a"
import script from "./MyComments.vue?vue&type=script&lang=ts"
export * from "./MyComments.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports